import { ShowDate } from 'framework/ui/ui-builder';
import { useShowContext } from 'framework/show';
import TimelineRecordAuthorWithAccessCheck from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/TimelineRecordAuthorWithAccessCheck';
import { DATE_FORMAT } from 'framework/utils';
import { Box, Typography } from '@mui/material';
import { timelineCardDateTimeSx, timelineCardHeaderSx } from './baseTimelineRecordSx';

type TimelineSentFeedbackHeaderProps = {
  actionName?: string | ((string: Dictionary<any>) => string);
};

const TimelineSentFeedbackHeader = ({ actionName = '' }: TimelineSentFeedbackHeaderProps) => {
  const { data: entity } = useShowContext();
  const createdAt = entity.getValueBySource('createdAt');
  const employeeId = entity.getValueBySource('employeeId');
  const employeeName = entity.getValueBySource('employeeName');
  const resultActionName = typeof actionName === 'function' ? actionName(entity.getData()) : actionName;

  return (
    <Box sx={timelineCardHeaderSx}>
      <Box>
        <Box sx={timelineCardDateTimeSx}>
          <ShowDate dateUTC={createdAt} format={DATE_FORMAT.FULL} />
        </Box>
        <Typography component="span" variant="body1">
          Sent to{' '}
        </Typography>
        <TimelineRecordAuthorWithAccessCheck id={employeeId} name={employeeName} /> {resultActionName}
      </Box>
    </Box>
  );
};

export default TimelineSentFeedbackHeader;
